/*
 *   Copyright (c) 2023 
 *   All rights reserved.
 */
import React from "react";
import NoDataTableSvg from "../../../assets/NoDataSvg/noDataTableSvg";

const VmoNoDataTable = ({ imageSrc, noDataText, noDataSubText }) => {
  return (
    <div className="no-data-design">
      {imageSrc ? (
        <img style={{ maxWidth: "100%" }} src={imageSrc} />
      ) : (
        <NoDataTableSvg />
      )}

      <p>{noDataText || ""}</p>
      <span>{noDataSubText || ""}</span>
    </div>
  );
};

export default VmoNoDataTable;
